function Footer() {
  return (
    <footer className="mt-5 grid gap-4 rounded-3xl border border-white/80 bg-white/75 px-7 py-6 shadow-glow backdrop-blur-xl lg:grid-cols-[1fr_auto] lg:items-center">
      <div>
        <p className="m-0 text-base font-extrabold">CoverGrid</p>
        <p className="mt-1 text-sm text-slate-500">
          Insurance discovery and renewal for modern Indian households.
        </p>
      </div>
      <p className="m-0 text-sm text-slate-500">
        Built for scalable insurance journeys with a modular React app structure.
      </p>
    </footer>
  );
}

window.AppLayout = window.AppLayout || {};
window.AppLayout.Footer = Footer;
